import { useMutation } from '@tanstack/react-query';

import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';
import { USER_DETAIL_QUERY_KEYS } from '../common/queryKeys';

export const useEditUserDetailInfoQuery = ({ userId, options }) => {
  const { mutateAsync } = useMutation(
    [...USER_DETAIL_QUERY_KEYS.USER_INFO_EDIT, userId],
    async (payload) => {
      const result = await AccountUserApi.editUserDetail(setRequestForm(payload, true));
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    { ...options },
  );

  return { editUserDetailInfoMutate: mutateAsync };
};
